module.exports = __webpack_public_path__ + "img/default-zone-image.219ccda1.jpg";